import { useCallback, useEffect, useState } from 'react';
import { listarUnidadesMinisteriais, UnidadeMinisterial } from '../../api/scmmp';
import Alert from '../../components/ui/Alert';
import LoadingSpinner from '../../components/ui/LoadingSpinner';
import { useAppSelector } from '../../hooks/use-app-selector';
import useHttp from '../../hooks/use-http';

const UnidadesMinisteriaisPage: React.FC = (): React.ReactElement => {
  const {
    sendRequest,
    status,
    error,
    data: unidadesMinisteriais,
  }: { data: UnidadeMinisterial[]; error: string; status: string; sendRequest: any } = useHttp(
    listarUnidadesMinisteriais
  );
  const { token } = useAppSelector((state) => state.auth);

  const unidadesOrganicasSorted =
    unidadesMinisteriais !== null
      ? unidadesMinisteriais.sort((u1, u2) => u1.nome.localeCompare(u2.nome))
      : [];

  useEffect(() => {
    sendRequest(token);
  }, [sendRequest, token]);

  return (
    <div className="container mt-3">
      <h3 className="h3">Lista de unidades ministeriais</h3>
      {status !== 'completed' && <LoadingSpinner />}
      {status === 'completed' && error && <Alert message={error} type="danger" />}
      {status === 'completed' && !error && unidadesOrganicasSorted && (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Código</th>
              <th>Sigla (máx. 20 caracteres)</th>
              <th>Nome da unidade</th>
            </tr>
          </thead>
          <tbody>
            {unidadesOrganicasSorted.map((unidadeMinisterial) => (
              <tr key={unidadeMinisterial.id}>
                <td>{unidadeMinisterial.id}</td>
                <td>{unidadeMinisterial.sigla}</td>
                <td>{unidadeMinisterial.nome}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UnidadesMinisteriaisPage;
